export function disableSubmit() {
	const disableSubmitButtons = document.querySelectorAll('[data-form-submit-disable]');

	disableSubmitButtons.forEach(button => {
		button.addEventListener('click', e => setTimeout(function () {
			button.setAttribute('disabled', 'disabled')
		}));
	});
}
